import Vue from "vue";

import ActionDispatcher from "./ActionDispatcher.vue";
import Confirmation from "./Confirmation.vue";
import FormRadio from "./FormRadio.vue";
import FormGroup from "./FormGroup.vue";
import Snackbar from "./Snackbar.vue";
import Loading from "./Loading.vue";

Vue.component("action-dispatcher", ActionDispatcher);
Vue.component("confirmation", Confirmation);
Vue.component("form-radio", FormRadio);
Vue.component("form-group", FormGroup);
Vue.component("snackbar", Snackbar);
Vue.component("loading", Loading);
